module.exports = __webpack_public_path__ + "static/media/ios-cash.2d670abc.svg";